import env from '../../../../config/environment'

var service = 'cidade';

angular.module('eficienciaFiscalModule')
    .service(service + 'Service', ['$timeout', 'httpService', 'pathService',
        function ($timeout, httpService, pathService) {

            var route = pathService.getApiUrl() + '/base/cidade/',
                backendRoute = env.api_url + '/cidades/',
                screenId = "#base";

            this.search = function (params, callback, event, loadText) {
                return httpService.request({
                    url: backendRoute,
                    method: "GET",
                    params: params,
                    blockScreen: true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            }

            this.get = function (id, callback, event, loadText) {
                httpService.request({
                    url: route,
                    method: "PUT",
                    data: {
                        "function": "buscar_por_estado",
                        "id": id
                    },
                    blockScreen: true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            }

            this.getById = function (id, callback, event, loadText) {
                httpService.request({
                    url: route + id,
                    method: "GET",
                    blockScreen: true,
                    screenId: screenId,
                    clickEvent: event,
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data[0]);
                    }
                })
            }

            this.select2Options = function () {
                return {
                    formatSearching: function () {
                        return'Pesquisando...';
                    },
                    formatNoMatches: function (term) {
                        return "Nenhum resultado para '" + term + "'";
                    },
                    formatInputTooShort: function (term, minLength) {
                        return "Por favor entre com mais " + (minLength - term.length) + ((minLength - term.length == 1) ? " caractere" : " caracteres");
                    },
                    minimumInputLength: 3,
                    ajax: {
                        type: "post",
                        url: route,
                        data: function (term, page) {
                            return {
                                query: term
                            };
                        },
                        results: function (data, page) {
                            var lista = [];
                            angular.forEach(data, function (value, index) {
                                lista.push(
                                    {
                                        id: value.id,
                                        text: value.nome + ' - ' + value.estado_nome
                                    }
                                );
                            });
                            return {results: lista};
                        }
                    }
                };
            }

            this.getByQuery = function (query, callback, event, loadText) {
                httpService.request({
                    url: route,
                    method: "POST",
                    blockScreen: true,
                    screenId: screenId,
                    clickEvent: event,
                    data: {
                        query: query
                    },
                    loadingText: loadText,
                    onSuccess: function (data) {
                        if (callback)
                            callback(data);
                    }
                })
            }
        }
    ]);
